export default __webpack_public_path__ + "static/mask-4c91751d67611d7a6763711bf362104c.png";